import clickOutsideDirective from 'tscore/directives/click-outside/click-outside-directive'
import createAPIService from 'frontcore/data/api-service/create-api-service'
import { App } from 'vue'

const configureApplication = (instance: App<Element>) => {
  createAPIService()
  instance.directive('click-outside', clickOutsideDirective)
  
}
export default configureApplication
